import { render, staticRenderFns } from "./PhotoRow.vue?vue&type=template&id=4a86c57b&"
import script from "./PhotoRow.vue?vue&type=script&lang=ts&"
export * from "./PhotoRow.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports